<template>
  <g class="areas">
    <path
      v-if="active == 'csi'"
      fill="url(#color)"
      opacity="0.5"
      d="M403,674.5c42.8,0,77.5-34.7,77.5-77.5s-34.7-77.5-77.5-77.5s-77.5,34.7-77.5,77.5S360.2,674.5,403,674.5
   M300.9,958.7l0.1,0c0,0,18-127.7-57-202.7S41.2,698.9,41.2,698.9c0.2,0.5,0.4,1.1,0.7,1.6C15,639.1,0,571.3,0,500
  C0,297.3,120.6,122.8,294,44.3c0.4-0.2,0.8-0.4,1.2-0.5c1.8-0.8,3.6-1.6,5.4-2.4c0.1-0.1,0.3-0.1,0.4-0.2c0,0,163,117.7,296,419.2
  C730,762,495.1,999.9,495.1,999.9C426.1,999.3,360.5,984.6,300.9,958.7"
    />
    <path
      v-if="active == 'csd'"
      fill="url(#color)"
      opacity="0.5"
      d="M605,460.5c42.8-135.2,0-268.5,0-268.5s-108,38-184-8S301,41.2,301,41.2c0,0,0,0,0,0C123.9,118.2,0,294.6,0,500
  c0,66.9,13.2,130.7,37,189c52.7,41,135,73.1,220.5,73.1C414.5,762.2,562.2,595.7,605,460.5"
    />
    <path
      v-if="active == 'cs'"
      fill="url(#color)"
      opacity="0.5"
      d="M-0.1,500c0-205.4,123.9-381.8,300.9-458.8c0,0,0.1,0,0.1,0c0,0,133,108.8,133,264.8s-73.9,198.6-110,306
  c-36,107-23,346.8-23,346.8c0,0,0,0,0,0C123.8,881.9-0.1,705.4-0.1,500L-0.1,500z"
    />
    <path
      v-if="active == 'cis'"
      fill="url(#color)"
      opacity="0.5"
      d="M403,674.5c42.8,0,77.5-34.7,77.5-77.5s-34.7-77.5-77.5-77.5s-77.5,34.7-77.5,77.5S360.2,674.5,403,674.5
   M689,963c-56.9,23.2-118.9,36.3-184,36.9c-0.7-2.7-61.2-126.4-117.5-191.9S226,674.9,194.3,607.2C162.5,539.6,209,337.7,41.2,301
  l0,0C91.7,184.9,184.9,91.6,301,41.2c0.1,0.1,184,155.8,296,415.7C708.3,715.3,689.2,960,689,963"
    />
    <path
      v-if="active == 'cid'"
      fill="url(#color)"
      opacity="0.5"
      d="M674.5,403c0,42.8-34.7,77.5-77.5,77.5s-77.5-34.7-77.5-77.5s34.7-77.5,77.5-77.5S674.5,360.2,674.5,403
   M963,689c23.2-56.9,36.3-118.9,36.9-184c-2.7-0.7-126.4-61.2-191.9-117.5S674.9,226,607.2,194.3S337.7,209,301,41.2l0,0
  C184.9,91.7,91.6,184.9,41.2,301c0.1,0.1,155.8,184,415.7,296C715.3,708.3,960,689.2,963,689"
    />
    <path
      v-if="active == 'ci'"
      fill="url(#color)"
      opacity="0.5"
      d="M41.2,301c0,0,89,107.8,204.2,159.4c115.3,51.6,157,52.3,282.1,149.2c125.2,96.9,230.1,204,173.6,348.2
  c55.3-24.3,107.1-59,152.4-104.3c45.3-45.3,80-97.1,104.3-152.4c-144.2,56.5-251.4-48.4-348.2-173.6
  C512.7,402.4,512,360.7,460.4,245.4C408.8,130.2,301,41.2,301,41.2c-58.1,25.2-110.4,61.1-154.5,105.3S66.4,242.9,41.2,301"
    />
    <path
      v-if="active == 'cds'"
      fill="url(#color)"
      opacity="0.5"
      d="M460.5,605c-135.2,42.8-268.5,0-268.5,0s38-108-8-184S41.2,301,41.2,301c0,0,0,0,0,0C118.2,123.9,294.6,0,500,0
  c66.9,0,130.7,13.2,189,37c41,52.7,73.1,135,73.1,220.5C762.2,414.5,595.7,562.2,460.5,605"
    />
    <path
      v-if="active == 'cdi'"
      fill="url(#color)"
      opacity="0.5"
      d="M674.5,403c0,42.8-34.7,77.5-77.5,77.5s-77.5-34.7-77.5-77.5s34.7-77.5,77.5-77.5S674.5,360.2,674.5,403
   M958.7,300.9l0,0.1c0,0-127.7,18-202.7-57S699,41.2,699,41.2c0.5,0.2,1.1,0.4,1.6,0.7C639.2,15,571.4,0,500,0
  C297.3,0,122.8,120.6,44.3,294c-0.2,0.4-0.4,0.8-0.5,1.2c-0.8,1.8-1.6,3.6-2.4,5.4c-0.1,0.1-0.1,0.3-0.2,0.4
  c0,0,117.7,163,419.2,296C762,730,1000,495.1,1000,495.1C999.3,426.1,984.7,360.5,958.7,300.9"
    />
    <path
      v-if="active == 'cd'"
      fill="url(#color)"
      opacity="0.5"
      d="M499.9,0C294.5,0,118.1,123.8,41.1,300.9c0,0,0,0.1,0,0.1c0,0,108.8,133,264.8,133s198.6-73.9,306-110
  c107-36,346.8-23,346.8-23c0,0,0,0,0,0C881.8,123.8,705.4,0,499.9,0L499.9,0z"
    />
    <path
      v-if="active == 'c'"
      fill="url(#color)"
      opacity="0.5"
      d="M494.9,407.5V0C222.7,2.6,2.6,222.8-0.1,495h407.5C455.8,495,494.9,455.8,494.9,407.5L494.9,407.5z"
    />
    <path
      v-if="active == 'sci'"
      fill="url(#color)"
      opacity="0.5"
      d="M605,539.5c42.8,135.2,0,268.5,0,268.5s-108-38-184,8S301,958.8,301,958.8c0,0,0,0,0,0
  C123.9,881.8,0,705.4,0,500c0-66.9,13.2-130.7,37-189c52.7-41,135-73.1,220.5-73.1C414.5,237.8,562.2,404.3,605,539.5"
    />
    <path
      v-if="active == 'scd'"
      fill="url(#color)"
      opacity="0.5"
      d="M403,325.5c42.8,0,77.5,34.7,77.5,77.5s-34.7,77.5-77.5,77.5s-77.5-34.7-77.5-77.5S360.2,325.5,403,325.5
   M300.9,41.3l0.1,0c0,0,18,127.7-57,202.7S41.2,301.1,41.2,301.1c0.2-0.5,0.4-1.1,0.7-1.6C15,360.9,0,428.7,0,500
  c0,202.7,120.6,377.2,294,455.7c0.4,0.2,0.8,0.4,1.2,0.5c1.8,0.8,3.6,1.6,5.4,2.4c0.1,0.1,0.3,0.1,0.4,0.2c0,0,163-117.7,296-419.2
  C730,238,495.1,0.1,495.1,0.1C426.1,0.7,360.5,15.4,300.9,41.3"
    />
    <path
      v-if="active == 'sc'"
      fill="url(#color)"
      opacity="0.5"
      d="M-0.1,500c0,205.4,123.9,381.8,300.9,458.8c0,0,0.1,0,0.1,0c0,0,133-108.8,133-264.8s-73.9-198.6-110-306
  c-36-107-23-346.8-23-346.8c0,0,0,0,0,0C123.8,118.1-0.1,294.6-0.1,500L-0.1,500z"
    />
    <path
      v-if="active == 'sic'"
      fill="url(#color)"
      opacity="0.5"
      d="M460.5,395c-135.2-42.8-268.5,0-268.5,0s38,108-8,184S41.2,699,41.2,699c0,0,0,0,0,0
  c76.9,177.1,253.4,301,458.8,301c66.9,0,130.7-13.2,189-37c41-52.7,73.1-135,73.1-220.5C762.2,585.5,595.7,437.8,460.5,395"
    />
    <path
      v-if="active == 'sid'"
      fill="url(#color)"
      opacity="0.5"
      d="M674.5,597c0-42.8-34.7-77.5-77.5-77.5s-77.5,34.7-77.5,77.5s34.7,77.5,77.5,77.5S674.5,639.8,674.5,597
   M958.7,699.1l0-0.1c0,0-127.7-18-202.7,57s-57.1,202.8-57.1,202.8c0.5-0.2,1.1-0.4,1.6-0.7C639.1,985,571.3,1000,500,1000
  c-202.7,0-377.2-120.6-455.7-294c-0.2-0.4-0.4-0.8-0.5-1.2c-0.8-1.8-1.6-3.6-2.4-5.4c-0.1-0.1-0.1-0.3-0.2-0.4
  c0,0,117.7-163,419.2-296C762,270,999.9,504.9,999.9,504.9C999.3,573.9,984.6,639.5,958.7,699.1"
    />
    <path
      v-if="active == 'si'"
      fill="url(#color)"
      opacity="0.5"
      d="M499.9,1000c-205.4,0-381.8-123.8-458.8-300.9c0,0,0-0.1,0-0.1c0,0,108.8-133,264.8-133s198.6,73.9,306,110
  c107,36,346.8,23,346.8,23s0,0,0,0C881.8,876.1,705.4,1000,499.9,1000L499.9,1000z"
    />
    <path
      v-if="active == 'sdc'"
      fill="url(#color)"
      opacity="0.5"
      d="M403,325.5c42.8,0,77.5,34.7,77.5,77.5s-34.7,77.5-77.5,77.5s-77.5-34.7-77.5-77.5S360.2,325.5,403,325.5
   M689,37C632.1,13.8,570.1,0.7,505,0.1c-0.7,2.7-61.2,126.4-117.5,191.9S226,325.1,194.3,392.8S209,662.3,41.2,699l0,0
  C91.7,815.1,184.9,908.4,301,958.8c0.1-0.1,184-155.8,296-415.7C708.3,284.7,689.2,40,689,37"
    />
    <path
      v-if="active == 'sdi'"
      fill="url(#color)"
      opacity="0.5"
      d="M674.5,597c0-42.8-34.7-77.5-77.5-77.5s-77.5,34.7-77.5,77.5s34.7,77.5,77.5,77.5S674.5,639.8,674.5,597
   M963,311c23.2,56.9,36.3,118.9,36.9,184c-2.7,0.7-126.4,61.2-191.9,117.5S674.9,774,607.2,805.7c-67.6,31.8-269.5-14.7-306.2,153
  l0,0C184.9,908.3,91.6,815.1,41.2,699c0.1-0.1,155.8-184,415.7-296C715.3,291.7,960,310.8,963,311"
    />
    <path
      v-if="active == 'sd'"
      fill="url(#color)"
      opacity="0.5"
      d="M301,958.8c0,0,107.8-89,159.4-204.2c51.6-115.3,52.3-157,149.2-282.1c96.9-125.2,204-230.1,348.2-173.6
  c-24.3-55.3-59-107.1-104.3-152.4c-45.3-45.3-97.1-80-152.4-104.3c56.5,144.2-48.4,251.4-173.6,348.2
  C402.4,487.3,360.7,488,245.4,539.6C130.2,591.2,41.2,699,41.2,699c25.2,58.1,61.1,110.4,105.3,154.5S242.9,933.6,301,958.8"
    />
    <path
      v-if="active == 's'"
      fill="url(#color)"
      opacity="0.5"
      d="M407.4,505H-0.1c2.7,272.2,222.8,492.3,495.1,495V592.5C494.9,544.2,455.8,505,407.4,505L407.4,505z"
    />
    <path
      v-if="active == 'ics'"
      fill="url(#color)"
      opacity="0.5"
      d="M325.5,597c0-42.8,34.7-77.5,77.5-77.5s77.5,34.7,77.5,77.5s-34.7,77.5-77.5,77.5S325.5,639.8,325.5,597
   M37,311C13.8,367.9,0.7,429.9,0.1,495c2.7,0.7,126.4,61.2,191.9,117.5S325.1,774,392.8,805.7c67.6,31.8,269.5-14.7,306.2,153l0,0
  C815.1,908.3,908.4,815.1,958.8,699c-0.1-0.1-155.8-184-415.7-296C284.7,291.7,40,310.8,37,311"
    />
    <path
      v-if="active == 'icd'"
      fill="url(#color)"
      opacity="0.5"
      d="M597,325.5c-42.8,0-77.5,34.7-77.5,77.5s34.7,77.5,77.5,77.5s77.5-34.7,77.5-77.5S639.8,325.5,597,325.5
   M311,37C367.9,13.8,429.9,0.7,495,0.1c0.7,2.7,61.2,126.4,117.5,191.9S774,325.1,805.7,392.8c31.8,67.6-14.7,269.5,153,306.2l0,0
  C908.3,815.1,815.1,908.4,699,958.8c-0.1-0.1-184-155.8-296-415.7C291.7,284.7,310.8,40,311,37"
    />
    <path
      v-if="active == 'ic'"
      fill="url(#color)"
      opacity="0.5"
      d="M958.8,699c0,0-89-107.8-204.2-159.4c-115.3-51.6-157-52.3-282.1-149.2c-125.2-96.9-230.1-204-173.6-348.2
  c-55.3,24.3-107.1,59-152.4,104.3c-45.3,45.3-80,97.1-104.3,152.4c144.2-56.5,251.4,48.4,348.2,173.6
  c96.9,125.2,97.6,166.9,149.2,282.1C591.2,869.8,699,958.8,699,958.8c58.1-25.2,110.4-61.1,154.5-105.3
  C897.7,809.4,933.6,757.1,958.8,699"
    />
    <path
      v-if="active == 'isc'"
      fill="url(#color)"
      opacity="0.5"
      d="M325.5,597c0-42.8,34.7-77.5,77.5-77.5s77.5,34.7,77.5,77.5s-34.7,77.5-77.5,77.5S325.5,639.8,325.5,597
   M41.3,699.1l0-0.1c0,0,127.7-18,202.7,57s57.1,202.8,57.1,202.8c-0.5-0.2-1.1-0.4-1.6-0.7C360.9,985,428.7,1000,500,1000
  c202.7,0,377.2-120.6,455.7-294c0.2-0.4,0.4-0.8,0.5-1.2c0.8-1.8,1.6-3.6,2.4-5.4c0.1-0.1,0.1-0.3,0.2-0.4c0,0-117.7-163-419.2-296
  C238,270,0.1,504.9,0.1,504.9C0.7,573.9,15.4,639.5,41.3,699.1
  "
    />
    <path
      v-if="active == 'isd'"
      fill="url(#color)"
      opacity="0.5"
      d="M539.5,395c135.2-42.8,268.5,0,268.5,0s-38,108,8,184s142.8,120,142.8,120c0,0,0,0,0,0
  c-76.9,177.1-253.4,301-458.8,301c-66.9,0-130.7-13.2-189-37c-41-52.7-73.1-135-73.1-220.5C237.8,585.5,404.3,437.8,539.5,395"
    />
    <path
      v-if="active == 'is'"
      fill="url(#color)"
      opacity="0.5"
      d="M499.9,1000c205.4,0,381.8-123.8,458.8-300.9c0,0,0-0.1,0-0.1c0,0-108.8-133-264.8-133s-198.6,73.9-306,110
  c-107,36-346.8,23-346.8,23c0,0,0,0,0,0C118,876.1,294.5,1000,499.9,1000L499.9,1000z"
    />
    <path
      v-if="active == 'idc'"
      fill="url(#color)"
      opacity="0.5"
      d="M597,325.5c-42.8,0-77.5,34.7-77.5,77.5s34.7,77.5,77.5,77.5s77.5-34.7,77.5-77.5S639.8,325.5,597,325.5
   M699.1,41.3l-0.1,0c0,0-18,127.7,57,202.7s202.8,57.1,202.8,57.1c-0.2-0.5-0.4-1.1-0.7-1.6C985,360.9,1000,428.7,1000,500
  c0,202.7-120.6,377.2-294,455.7c-0.4,0.2-0.8,0.4-1.2,0.5c-1.8,0.8-3.6,1.6-5.4,2.4c-0.1,0.1-0.3,0.1-0.4,0.2
  c0,0-163-117.7-296-419.2C270,238,504.9,0.1,504.9,0.1C573.9,0.7,639.5,15.4,699.1,41.3"
    />
    <path
      v-if="active == 'ids'"
      fill="url(#color)"
      opacity="0.5"
      d="M395,539.5c-42.8,135.2,0,268.5,0,268.5s108-38,184,8s120,142.8,120,142.8c0,0,0,0,0,0
  c177.1-76.9,301-253.4,301-458.8c0-66.9-13.2-130.7-37-189c-52.7-41-135-73.1-220.5-73.1C585.5,237.8,437.8,404.3,395,539.5"
    />
    <path
      v-if="active == 'id'"
      fill="url(#color)"
      opacity="0.5"
      d="M1000,500c0,205.4-123.9,381.8-300.9,458.8c0,0-0.1,0-0.1,0c0,0-133-108.8-133-264.8s73.9-198.6,110-306
  c36-107,23-346.8,23-346.8c0,0,0,0,0,0C876.1,118.1,1000,294.6,1000,500L1000,500z"
    />
    <path
      v-if="active == 'i'"
      fill="url(#color)"
      opacity="0.5"
      d="M504.9,592.5V1000c272.2-2.7,492.4-222.8,495.1-495H592.5C544.1,505,504.9,544.2,504.9,592.5L504.9,592.5z"
    />
    <path
      v-if="active == 'dcs'"
      fill="url(#color)"
      opacity="0.5"
      d="M325.5,403c0,42.8,34.7,77.5,77.5,77.5s77.5-34.7,77.5-77.5s-34.7-77.5-77.5-77.5S325.5,360.2,325.5,403
   M41.3,300.9l0,0.1c0,0,127.7,18,202.7-57s57.1-202.8,57.1-202.8c-0.5,0.2-1.1,0.4-1.6,0.7C360.9,15,428.7,0,500,0
  c202.7,0,377.2,120.6,455.7,294c0.2,0.4,0.4,0.8,0.5,1.2c0.8,1.8,1.6,3.6,2.4,5.4c0.1,0.1,0.1,0.3,0.2,0.4c0,0-117.7,163-419.2,296
  C238,730,0.1,495.1,0.1,495.1C0.7,426.1,15.4,360.5,41.3,300.9"
    />
    <path
      v-if="active == 'dci'"
      fill="url(#color)"
      opacity="0.5"
      d="M539.5,605c135.2,42.8,268.5,0,268.5,0s-38-108,8-184s142.8-120,142.8-120c0,0,0,0,0,0
  C881.8,123.9,705.4,0,500,0c-66.9,0-130.7,13.2-189,37c-41,52.7-73.1,135-73.1,220.5C237.8,414.5,404.3,562.2,539.5,605"
    />
    <path
      v-if="active == 'dc'"
      fill="url(#color)"
      opacity="0.5"
      d="M499.9,0c205.4,0,381.8,123.8,458.8,300.9c0,0,0,0.1,0,0.1c0,0-108.8,133-264.8,133s-198.6-73.9-306-110
  c-107-36-346.8-23-346.8-23c0,0,0,0,0,0C118,123.8,294.5,0,499.9,0L499.9,0z"
    />
    <path
      v-if="active == 'dsc'"
      fill="url(#color)"
      opacity="0.5"
      d="M325.5,403c0,42.8,34.7,77.5,77.5,77.5s77.5-34.7,77.5-77.5s-34.7-77.5-77.5-77.5S325.5,360.2,325.5,403
   M37,689C13.8,632.1,0.7,570.1,0.1,505c2.7-0.7,126.4-61.2,191.9-117.5S325.1,226,392.8,194.3S662.3,209,699,41.2l0,0
  C815.1,91.7,908.4,184.9,958.8,301c-0.1,0.1-155.8,184-415.7,296C284.7,708.3,40,689.2,37,689"
    />
    <path
      v-if="active == 'dsi'"
      fill="url(#color)"
      opacity="0.5"
      d="M597,674.5c-42.8,0-77.5-34.7-77.5-77.5s34.7-77.5,77.5-77.5s77.5,34.7,77.5,77.5S639.8,674.5,597,674.5
   M311,963c56.9,23.2,118.9,36.3,184,36.9c0.7-2.7,61.2-126.4,117.5-191.9S774,674.9,805.7,607.2c31.8-67.6-14.7-269.5,153-306.2l0,0
  C908.3,184.9,815.1,91.6,699,41.2c-0.1,0.1-184,155.8-296,415.7C291.7,715.3,310.8,960,311,963"
    />
    <path
      v-if="active == 'ds'"
      fill="url(#color)"
      opacity="0.5"
      d="M699,41.2c0,0-107.8,89-159.4,204.2c-51.6,115.3-52.3,157-149.2,282.1c-96.9,125.2-204,230.1-348.2,173.6
  c24.3,55.3,59,107.1,104.3,152.4c45.3,45.3,97.1,80,152.4,104.3c-56.5-144.2,48.4-251.4,173.6-348.2
  c125.2-96.9,166.9-97.6,282.1-149.2C869.8,408.8,958.8,301,958.8,301c-25.2-58.1-61.1-110.4-105.3-154.5
  C809.4,102.3,757.1,66.4,699,41.2"
    />
    <path
      v-if="active == 'dis'"
      fill="url(#color)"
      opacity="0.5"
      d="M597,674.5c-42.8,0-77.5-34.7-77.5-77.5s34.7-77.5,77.5-77.5s77.5,34.7,77.5,77.5S639.8,674.5,597,674.5
   M699.1,958.7l-0.1,0c0,0-18-127.7,57-202.7s202.8-57.1,202.8-57.1c-0.2,0.5-0.4,1.1-0.7,1.6C985,639.1,1000,571.3,1000,500
  c0-202.7-120.6-377.2-294-455.7c-0.4-0.2-0.8-0.4-1.2-0.5c-1.8-0.8-3.6-1.6-5.4-2.4c-0.1-0.1-0.3-0.1-0.4-0.2
  c0,0-163,117.7-296,419.2C270,762,504.9,999.9,504.9,999.9C573.9,999.3,639.5,984.6,699.1,958.7
  "
    />
    <path
      v-if="active == 'dic'"
      fill="url(#color)"
      opacity="0.5"
      d="M395,460.5c-42.8-135.2,0-268.5,0-268.5s108,38,184-8S699,41.2,699,41.2c0,0,0,0,0,0
  c177.1,76.9,301,253.4,301,458.8c0,66.9-13.2,130.7-37,189c-52.7,41-135,73.1-220.5,73.1C585.5,762.2,437.8,595.7,395,460.5"
    />
    <path
      v-if="active == 'di'"
      fill="url(#color)"
      opacity="0.5"
      d="M1000,500c0-205.4-123.9-381.8-300.9-458.8c0,0-0.1,0-0.1,0c0,0-133,108.8-133,264.8s73.9,198.6,110,306
  c36,107,23,346.8,23,346.8s0,0,0,0C876.1,881.9,1000,705.4,1000,500L1000,500z"
    />
    <path
      v-if="active == 'd'"
      fill="url(#color)"
      opacity="0.5"
      d="M592.5,495H1000C997.3,222.8,777.2,2.6,504.9,0v407.5C504.9,455.8,544.1,495,592.5,495L592.5,495z"
    />
  </g>
</template>

<script>
export default {
  props: {
    activeArea: {
      required: false,
      default: Object,
    },
  },

  watch: {
    activeArea: function (newVal, oldVal) {
      this.active = newVal;
    },
  },

  data() {
    return {
      active: null,
    };
  },
};
</script>